import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Idea } from '../../../../models/Sessions/Idea/Idea';
import { Session } from '../../../../models/Sessions/Session';
import { BusService } from '../../../../services/bus.service';
import { EventsService } from '../../../../services/events.service';

@Component({
  selector: 'app-user-feedback',
  standalone: true,
  imports: [CommonModule, FormsModule, CdkTextareaAutosize],
  templateUrl: './user-feedback.component.html',
  styleUrl: './user-feedback.component.scss',
  host: {
    class: 'd-flex flex-column gap-2 p-2 border rounded bg-warning-subtle',
  },
})
export class UserFeedbackComponent {
  @Input() session: Session;
  @Input() idea: Idea;

  rate = null;
  comment = null;

  showSuccessMessage = false;

  constructor(
    private bus: BusService,
    private events: EventsService,
  ) {}

  onSubmit() {
    if (!this.rate && !this.comment) {
      return;
    }

    this.bus.publish(
      this.events.requested.action.session.idea.feedback.post,
      this.session,
      this.idea,
      {
        rate: this.rate,
        comment: this.comment,
      },
    );

    this.clear();
    this.showSuccessMessage = true;

    setTimeout(() => {
      this.showSuccessMessage = false;
    }, 3000);
  }

  clear() {
    this.rate = null;
    this.comment = null;
  }
}
